import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Cart Link Config"})
export default class CartLinkPanelConfig {

	@Input({type: InputType.CHECKBOX, title: "Hide when cart is empty"})
	public hideWhenEmpty: boolean = false;

}



// WEBPACK FOOTER //
// ./src/panels/catalog/config/CartLinkPanelConfig.ts